import { createFileRoute } from "@tanstack/react-router";
import { MissionKit } from "@/features/missionkit/mission-kit";

/**
 * Design/preview page — the kit with the generic loadout.
 * The real one is /missionkit/code/$code/$missionId.
 *
 * `?mission=<id>` stages it against a real mission, so the preview can show
 * the briefing on the paper and the mission's own clip through the glasses.
 * Without it the kit still opens, just with nothing staged behind it — which
 * is a thinner page than the one operatives get, and worth knowing you are
 * looking at.
 */
export const Route = createFileRoute("/missionkit")({
  validateSearch: (search: Record<string, unknown>) => ({
    mission: search.mission ? String(search.mission) : undefined,
  }),
  component: MissionKitPreview,
});

function MissionKitPreview() {
  const { mission } = Route.useSearch();
  return <MissionKit missionId={mission} />;
}
